import * as React from "react";
import { forwardRef, memo } from "react";

const SvgCirclePlusIcon = (props, ref) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <circle cx={12} cy={12} r={8} stroke="#ADADAD" strokeWidth={1.5} />
    <path
      d="M12 8v8M16 12H8"
      stroke="#ADADAD"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
  </svg>
);

const ForwardRef = forwardRef(SvgCirclePlusIcon);
const Memo = memo(ForwardRef);
export default Memo;
